import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b4d61f70&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b4d61f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d61f70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d61f70')) {
      api.createRecord('b4d61f70', component.options)
    } else {
      api.reload('b4d61f70', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b4d61f70&scoped=true&", function () {
      api.rerender('b4d61f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-225bN8qqTdXRX/JS/comp/SearchFilterTokens.vue"
export default component.exports